var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconmaterialGroupWork(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-group-work",
    "data-name": "Icon material-group-work",
    d: "M9.5,3A6.5,6.5,0,1,0,16,9.5,6.5,6.5,0,0,0,9.5,3ZM6.9,13.075A1.625,1.625,0,1,1,8.525,11.45,1.626,1.626,0,0,1,6.9,13.075ZM7.875,6.9A1.625,1.625,0,1,1,9.5,8.525,1.626,1.626,0,0,1,7.875,6.9ZM12.1,13.075a1.625,1.625,0,1,1,1.625-1.625A1.626,1.626,0,0,1,12.1,13.075Z",
    transform: "translate(-3 -3)",
    fill: "#7a7a7a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconmaterialGroupWork);
export default __webpack_public_path__ + "static/media/Icon material-group-work.4e01d559.svg";
export { ForwardRef as ReactComponent };